/**
 * This custom directive handles click events on links that have an href to a cluster specific link
 * The link with the same domian should be passed to this directive as binding.
 * The cluster specific link can be passed in href attribute so that it can be openened in new tab.
 */
const anchorLinkCluster = {
  bind: function(el, binding, vueNode){
    if(binding.value){
      el.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        console.log(binding.value, vueNode.context.$router);
        vueNode.context.$router.push({path: binding.value});
      })
    }
  }
}

/**
 * Global directives object
 */
const directives = {
  anchorLinkCluster
};

export default directives;
